export function getPageinfo ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pageinfo')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCreatePageinfo ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pageinfo/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createPageinfo ({ state, commit }, { contentName, content }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pageinfo', { contentName, content })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditPageinfo ({ state, commit }, pId) {
  return new Promise((resolve, reject) => {
    if (pId) {
      axiosInstance.get('/v1/pageinfo/' + pId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No page info id'))
    }
  })
}

export function editPageinfo ({ state, commit }, { id, contentName, content }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/pageinfo/' + id, { id, contentName, content })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No page info id'))
    }
  })
}
